export default __webpack_public_path__ + "static/media/promo-banner-ETH-staking.e50f2145.svg";